export default __webpack_public_path__ + "static/media/menu-admin-payouts.fa96af96.png";